import { $ModuleArea, ModuleArea } from '@suntex.fim/enums';

import { NodeModel } from '../../../types';

const moduleAreaDesc = $ModuleArea.describe(ModuleArea.ComputationalThinking);

export const ctNode: NodeModel = {
  tag: moduleAreaDesc.slug,
  info: {
    title: moduleAreaDesc.label,
  },
  label: {
    aria: moduleAreaDesc.label,
    class: 'MainLabel',
    frame: 10,
  },
  color: moduleAreaDesc.color,
  children: [
    {
      tag: 'k2-ct',
      icon: 'games/k2-ct',
      label: 'K2\nCT',
      color: 0x0099ff,
      children: [
        {
          moduleSlug: 'k2-missing-icons-ct',
          icon: 'games/k2-missing-icons-ct',
          label: 'K2 Missing\nIcons CT',
          color: 0x3399ff,
        },
        {
          moduleSlug: 'k2-pundis-puzzle-ct',
          icon: 'games/k2-pundis-puzzle-ct',
          label: "K2 Pundi's\nPuzzle CT",
          color: 0x39b54a,
        },
        {
          moduleSlug: 'k2-rps-ct',
          icon: 'games/k2-rps-ct',
          label: 'K2 RPS\nChess CT',
          color: 0x66a9e5,
        },
        {
          moduleSlug: 'k2-monus-path-ct',
          icon: 'games/k2-monus-path-ct',
          label: "K2 Monu's\nPath CT",
          color: 0xff6600,
        },
        {
          moduleSlug: 'k2-misfits-num-ct',
          icon: 'games/k2-misfits-num-ct',
          label: 'K2 Numbers\nMisfits CT',
          color: 0xff8800,
        },
        {
          moduleSlug: 'k2-what-belongs-ct',
          icon: 'games/k2-what-belongs-ct',
          label: 'K2 What\nBelongs CT',
          color: 0xffcc00,
        },
      ],
    },
    {
      moduleSlug: 'misfits-newb',
      icon: 'games/misfits-newb',
      label: 'Misfits Newb',
      color: 0xff3333,
    },
    {
      moduleSlug: 'rps-newb-ct',
      icon: 'games/rps-newb-ct',
      label: 'RPS Chess Newb Coding',
      color: 0xffb4c0,
    },
    {
      moduleSlug: 'misfits-num',
      icon: 'games/misfits-num',
      label: 'Numbers Misfits',
      color: 0x997ade,
    },
    {
      moduleSlug: 'rps-ct',
      icon: 'games/rps',
      label: 'RPS Chess Elite\nCoding',
      color: 0x87dcb9,
    },
    {
      moduleSlug: 'pundis-puzzle-ct',
      icon: 'games/pundis-puzzle',
      label: 'Coding\nPundis Puzzle',
      color: 0xaaf5aa,
    },
    {
      moduleSlug: 'zero-sum-newb',
      icon: 'games/zero-sum-newb',
      label: 'Zero Sum \nNewb',
      color: 0x00cce5,
    },
    {
      moduleSlug: 'factor-wheels-ct',
      icon: 'games/factor-wheels-ct',
      label: 'Factor Wheels \nCT',
      color: 0x99d433,
    },
    {
      moduleSlug: 'misfits-dec',
      icon: 'games/misfits-dec',
      label: 'Decimals\nMisfits',
      color: 0xa9a9a9,
    },
    {
      moduleSlug: 'misfits',
      icon: 'games/misfits',
      label: 'Misfits Elite',
      color: 0xff3333,
    },
    {
      moduleSlug: 'misfits-frc',
      icon: 'games/misfits-frc',
      label: '\nFractions Misfits',
      color: 0x6698ff,
    },
    {
      moduleSlug: 'rps-master-ct',
      icon: 'games/rps-master',
      label: '\nRPS Chess Epic Coding',
      color: 0xcbcbf1,
    },
    {
      moduleSlug: 'zero-sum',
      icon: 'games/zero-sum',
      label: 'Zero Sum',
      color: 0x335386,
    },
    {
      moduleSlug: 'misfits-master',
      icon: 'games/misfits-master',
      label: 'Misfits Epic',
      color: 0xff3333,
    },
  ],
};
